import React, { Component } from 'react';
import { IntlProvider, FormattedDate, addLocaleData } from 'react-intl';
import PropTypes from 'prop-types';
import it from 'react-intl/locale-data/it';

addLocaleData([...it]);

class EventShort extends Component {
    goToEvent = (param) => (e) => {
        const path= window.location.href + "concerti#event-" + param;
        window.location.href=path;
    }

    render() {
        return (
            <IntlProvider locale="it">
                <div className="row eventshort py-2" onClick={this.goToEvent(this.props.event.id)}>
                    <div className="col-12 col-sm-2 font-bold">
                        <FormattedDate value={this.props.event.startdatetime} day="2-digit" month="short" />
                    </div>
                    <div className="col-12 col-sm-6 font-bold primary-cl">
                        {this.props.event.title}
                    </div>
                    <div className="col-12 col-sm-4 font-italic">
                    {this.props.event.location.city}
                    </div>
                </div>
            </IntlProvider>
        );
    }
}

EventShort.propTypes = {
    event: PropTypes.object.isRequired
};

export default EventShort;


// WEBPACK FOOTER //
// ./src/components/EventShort.js